import { useEffect, useState } from 'react';
import './globalStyles.css';
import { Routes, Route } from 'react-router-dom';
import { validateUser } from './utils/validateUser.js';
import { useNavigate } from 'react-router-dom';
import { useTelegramBackButton } from './hooks/useTelegramBackButton.js';

import { HomePage } from './pages/home/public/homePage.jsx';
import { KeysHomePage } from './pages/home/keysAndServices/homePage.jsx';
import { HomePage as SharingHomePage } from './pages/home/sharing/HomePage.jsx';
import { SearchPage } from './pages/search/SearchPage.jsx';
import { WelcomePage } from './pages/welcome/WelcomePage.jsx';
import { ProfilePage } from './pages/profile/ProfilePage.jsx';
import { CatalogPage } from './pages/catalog/catalogPage.jsx';
import { CatalogCategoryPage } from './pages/catalog/category/CatalogCategoryPage.jsx';
import { CatalogGenrePage } from './pages/catalog/genre/CatalogGenrePage.jsx';
import { BasketPage } from './pages/basket/basketPage.jsx';
import { WishlistPage } from './pages/wishlist/wishlistPage.jsx';
import { OrderStoryPage } from './pages/orderStory/OrderStoryPage.jsx';
import { ItemPage } from './pages/item/ItemPage.jsx';
import { ItemPage as SharingItemPage } from './pages/item/sharing/ItemPage.jsx';

import { SteamAddingPage } from './pages/steam/adding/SteamAddingPage.jsx';
import { SteamCardsPage } from './pages/steam/cards/SteamCardsPage.jsx';

import { XboxPage } from './pages/xbox/XboxPage.jsx';

import { FifaPage } from './pages/fifa/FifaPage.jsx';

import { FAQPage } from './pages/FAQ/FAQPage.jsx';

import { AdminPage } from './pages/admin/AdminPage/AdminPage.jsx';
import { ItemsAdminPage } from './pages/admin/ItemsAdminPage/public/ItemsAdminPage.jsx';
import { ItemsAdminSchemasPage } from './pages/admin/ItemsAdminPage/keysAndServices/ItemsAdminPage.jsx';
import { SubsAdminPage } from './pages/admin/SubsAdminPage/SubsAdminPage.jsx';
import { DevicesAdminPage } from './pages/admin/DevicesAdminPage/DevicesAdminPage.jsx';
import { OrderAdminPage } from './pages/admin/OrderAdminPage/OrderAdminPage.jsx';
import { UsersAdminPage } from './pages/admin/UsersAdminPage/UsersAdminPage.jsx';
import { AddingOrderAdminPage } from './pages/admin/AddingOrderAdminPage/AddingOrderAdminPage.jsx';
import { PromoAdminPage } from './pages/admin/PromoAdminPage/PromoAdminPage.jsx';
import { XboxAdminPage } from './pages/admin/XboxAdminPage/XboxAdminPage.jsx';
import { SharingItemsAdminPage } from './pages/admin/ItemsAdminPage/sharing/SharingItemsAdminPage.jsx';
import { SettingsAdminPage } from './pages/admin/SettingsAdminPage/SettingsAdminPage.jsx';

import { UserAgreePage } from './pages/terms/UserAgree/UserAgreePage.jsx';
import { PrivacyPolicyPage } from './pages/terms/PrivacyPolicy/PrivacyPolicyPage.jsx';

import { useAuthUserMutation } from './store/api/user.api.js';
import { useActions } from './hooks/useActions.js';

import { AdminRoute } from './AdminRoute.jsx';
import { PrivateRoute } from './PrivateRoute.jsx';
import { Navigation } from './components/Nav/Navigation.jsx';

import './loader.css';

function App() {
  useTelegramBackButton()

  const env = process.env.REACT_APP_ENV;
  const [activeNavPage, setActiveNavPage] = useState(0);
  const [userAuth] = useAuthUserMutation();
  const [isValid, setIsValid] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const { setUser } = useActions();
  const [isFocus, setIsFocus] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const handleWebAppReady = () => {
      const tg = window.Telegram.WebApp;
      const startParam = tg?.initDataUnsafe?.start_param;

      if (startParam) {
        if (startParam.includes('ads')) {
          if (window.ym) {
            window.ym(103418336, 'params', { campaign: startParam });
            window.ym(103418336, 'reachGoal', 'traffic_source');
          }
        } else {
          const [rawPath, engQueryPart] = startParam.split("=");

          let queryPart = '';
          if (engQueryPart === 'distrib') queryPart = "Распродажа";
          else if (engQueryPart === 'under500') queryPart = "До 500";
          else if (engQueryPart === 'under1000') queryPart = "До 1000";
          else if (engQueryPart === 'russianLang') queryPart = "Полностью на русском";
          

          const parts = rawPath.replaceAll("-", "/").split("/");

          if (engQueryPart) {
            parts.pop()
          }

          const services = ["steam", "Nind_keys", "PS_keys", "valorant_keys", "PS_sharing", "xbox", "fifa", "services"];
          if (services.includes(parts[0])) {
            try {
              sessionStorage.setItem("schema", parts[0]);
            } catch (e) {
              console.warn("sessionStorage недоступен");
            }
            if (parts[parts.length - 1] === "schema") {
              parts.pop();
              parts.shift();
            }
          }

          let query = queryPart ? `?type=${encodeURIComponent(queryPart)}` : '';
          let finalPath = parts.join("/") + query;

          console.log("Navigate to:", finalPath);
          navigate(finalPath);
        }
      }

      validateUser({ env, setUser, userAuth, setIsValid, setIsLoading });
    };

    document.addEventListener('telegramWebAppInit', handleWebAppReady);

    // Если WebApp уже готов
    if (window.Telegram?.WebApp?.ready) handleWebAppReady();

    return () => {
      document.removeEventListener('telegramWebAppInit', handleWebAppReady);
    };
  }, []);

 
  const PrivateRouteWrapper = ({ children, pageIndex = 0 }) => (
    <PrivateRoute isValid={isValid} isLoading={isLoading} setActiveNavPage={setActiveNavPage} activeNavPage={pageIndex}>
      {children}
    </PrivateRoute>
  );

  return (
    <>
      <Routes>
        {/* Welcome */}
        <Route path="/" element={<PrivateRoute isValid={isValid} isLoading={isLoading}><WelcomePage /></PrivateRoute>} />

        {/* Home */}
        <Route path="/home" element={<PrivateRouteWrapper pageIndex={1}><HomePage /></PrivateRouteWrapper>} />
        <Route path="/PS_keys/home" element={<PrivateRouteWrapper pageIndex={1}><KeysHomePage /></PrivateRouteWrapper>} />
        <Route path="/Nind_keys/home" element={<PrivateRouteWrapper pageIndex={1}><KeysHomePage /></PrivateRouteWrapper>} />
        <Route path="/services/home" element={<PrivateRouteWrapper pageIndex={1}><KeysHomePage /></PrivateRouteWrapper>} />
        <Route path="/valorant_keys/home" element={<PrivateRouteWrapper pageIndex={1}><KeysHomePage /></PrivateRouteWrapper>} />
        <Route path="/PS_sharing/home" element={<PrivateRouteWrapper pageIndex={1}><SharingHomePage /></PrivateRouteWrapper>} />

        {/* Search */}
        <Route path="/search" element={<PrivateRouteWrapper pageIndex={0}><SearchPage /></PrivateRouteWrapper>} />

        {/* Profile */}
        <Route path="/profile" element={<PrivateRouteWrapper pageIndex={0}><ProfilePage /></PrivateRouteWrapper>} />
        <Route path="/PS_keys/profile" element={<PrivateRouteWrapper pageIndex={0}><ProfilePage /></PrivateRouteWrapper>} />

        {/* Catalog */}
        <Route path="/catalog" element={<PrivateRouteWrapper pageIndex={2}><CatalogPage /></PrivateRouteWrapper>} />
        <Route path="/catalog/category" element={<PrivateRoute isValid={isValid} isLoading={isLoading}><CatalogCategoryPage /></PrivateRoute>} />
        <Route path="/catalog/genre" element={<PrivateRoute isValid={isValid} isLoading={isLoading}><CatalogGenrePage /></PrivateRoute>} />

        {/* Basket & Wishlist */}
        <Route path="/basket" element={<PrivateRouteWrapper pageIndex={3}><BasketPage /></PrivateRouteWrapper>} />
        <Route path="/wishlist" element={<PrivateRouteWrapper pageIndex={4}><WishlistPage /></PrivateRouteWrapper>} />

        {/* Orders */}
        <Route path="/orders" element={<PrivateRouteWrapper><OrderStoryPage /></PrivateRouteWrapper>} />

        {/* Items */}
        <Route path="/items/:id" element={<PrivateRouteWrapper><ItemPage /></PrivateRouteWrapper>} />
        <Route path="/PS_sharing/items/:id" element={<PrivateRouteWrapper><SharingItemPage /></PrivateRouteWrapper>} />

        {/* Steam */}
        <Route path="/steam/adding" element={<PrivateRouteWrapper pageIndex={1}><SteamAddingPage setIsFocus={setIsFocus}/></PrivateRouteWrapper>} />
        <Route path="/steam/cards" element={<PrivateRouteWrapper pageIndex={2}><SteamCardsPage /></PrivateRouteWrapper>} />
        
        {/* xbox */}
        <Route path="/xbox" element={<PrivateRouteWrapper pageIndex={0}><XboxPage /></PrivateRouteWrapper>} />

        {/* fifa */}
        <Route path="/fifa" element={<PrivateRouteWrapper pageIndex={0}><FifaPage /></PrivateRouteWrapper>} />

        {/* FAQ */}
        <Route path="/FAQ" element={<PrivateRouteWrapper pageIndex={0}><FAQPage /></PrivateRouteWrapper>} />

        {/* Legal pages */}
        <Route path="/userAgree" element={<UserAgreePage />} />
        <Route path="/privacyPolicy" element={<PrivacyPolicyPage />} />
        

        {/* Admin */}
        <Route path="/admin" element={<AdminRoute><PrivateRoute isValid={isValid} isLoading={isLoading}><AdminPage /></PrivateRoute></AdminRoute>} />
        <Route path="/admin/settings" element={<AdminRoute><PrivateRoute isValid={isValid} isLoading={isLoading}><SettingsAdminPage /></PrivateRoute></AdminRoute>} />
        <Route path="/admin/promo" element={<AdminRoute><PrivateRoute isValid={isValid} isLoading={isLoading}><PromoAdminPage /></PrivateRoute></AdminRoute>} />
        <Route path="/admin/items" element={<AdminRoute><PrivateRoute isValid={isValid} isLoading={isLoading}><ItemsAdminPage /></PrivateRoute></AdminRoute>} />
        <Route path="/admin/schemasItems" element={<AdminRoute><PrivateRoute isValid={isValid} isLoading={isLoading}><ItemsAdminSchemasPage /></PrivateRoute></AdminRoute>} />
        <Route path="/admin/subs" element={<AdminRoute><PrivateRoute isValid={isValid} isLoading={isLoading}><SubsAdminPage /></PrivateRoute></AdminRoute>} />
        <Route path="/admin/devices" element={<AdminRoute><PrivateRoute isValid={isValid} isLoading={isLoading}><DevicesAdminPage /></PrivateRoute></AdminRoute>} />
        <Route path="/admin/orders" element={<AdminRoute><PrivateRoute isValid={isValid} isLoading={isLoading}><OrderAdminPage /></PrivateRoute></AdminRoute>} />
        <Route path="/admin/adding-orders" element={<AdminRoute><PrivateRoute isValid={isValid} isLoading={isLoading}><AddingOrderAdminPage /></PrivateRoute></AdminRoute>} />
        <Route path="/admin/users" element={<AdminRoute><PrivateRoute isValid={isValid} isLoading={isLoading}><UsersAdminPage /></PrivateRoute></AdminRoute>} />
        <Route path="/admin/xbox" element={<AdminRoute><PrivateRoute isValid={isValid} isLoading={isLoading}><XboxAdminPage /></PrivateRoute></AdminRoute>} />
        <Route path="/admin/sharing-items" element={<AdminRoute><PrivateRoute isValid={isValid} isLoading={isLoading}><SharingItemsAdminPage /></PrivateRoute></AdminRoute>} />
      </Routes>

        <Navigation
          hide={isFocus}
          activePage={activeNavPage}
          setActivePage={setActiveNavPage}
        />
    </>
  );
}

export default App;
